const AUTOSERVICE_PAYMENT = "autosrv3";
const AUTOSERVICE_SIMPLE = "autosrv0";

const DEFAULT_LANGUAGE = "es";

const ORIGIN_CONNECT = {
  tvtas: "mensajesTVentas",
  corpfav: "mensajesCorpFav",
  creditofav: "mensajesCreditoFav",
};

export {
  AUTOSERVICE_PAYMENT,
  AUTOSERVICE_SIMPLE,
  DEFAULT_LANGUAGE,
  ORIGIN_CONNECT,
};
